import React from 'react';

import { Box, Center, HStack, Stack, VStack } from '@chakra-ui/react';
import { map } from 'lodash';
import truncate from 'lodash/truncate';
import { customTheme } from 'theme';

import {
  CustomTooltip,
  formatNumberWithComma,
  renderTooltipFieldValue,
} from 'components/DataDisplay';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';

const colors = customTheme.colors;
export const firstLayerData = [
  {
    value: 25,
    color: colors.green['300'],
  },
  {
    value: 50,
    color: colors.yellow['400'],
  },
  {
    value: 25,
    color: colors.red['400'],
  },
];

export const tickData = () => {
  let data: { value: number }[] = [];
  for (let i = 0; i <= 100; i++) {
    data.push({ value: 0.5 });
  }
  return data;
};

export const bigTicksData = () => {
  let data: { value: number }[] = [];
  for (let i = 0; i < 11; i++) {
    data.push({ value: 1 });
  }
  return data;
};

export const customizedPieChartLegend = (value, entry, index) => {
  return (
    <span style={{ fontSize: '14px', color: '#666' }}>
      {truncate(value + ' (' + entry?.payload?.value + ')', {
        length: 20,
      })}
    </span>
  );
};

/*export const renderPieChartLegend = props => {
  return (
    <Box w="full" h="full" fontSize="14px" p={2} position="relative">
      <Center w="full" h="full" border="1px solid red">
        <Stack spacing={1} w="full" overflowY="visible" alignItems="center">
          {map(props?.payload, o => (
            <Box w="full">
              <CustomTooltip
                label={
                  <Stack>
                    {renderTooltipFieldValue('Name', o.value)}
                    {renderTooltipFieldValue(
                      'Value',
                      formatNumberWithComma(o?.payload?.value),
                    )}
                  </Stack>
                }
              >
                <HStack w="full">
                  <Box boxSize={2.5} bg={o?.color} borderRadius={3} />
                  <Box
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {o?.value} ({formatNumber(o?.payload?.value, 1)})
                  </Box>
                </HStack>
              </CustomTooltip>
            </Box>
          ))}
        </Stack>
      </Center>
    </Box>
  );
};*/

export const renderPieChartLegend = props => (
  <Center flex={1} w="full" minH="100%">
    <VStack w="full" fontSize="sm">
      <Stack w="full" spacing={1} alignItems="center" overflow="visible">
        {map(props?.payload, o => (
          <Box w="full" overflow="hidden">
            <CustomTooltip
              label={
                <Stack>
                  {renderTooltipFieldValue('Name', o.value)}
                  {renderTooltipFieldValue(
                    'Value',
                    formatNumberWithComma(o?.payload?.value),
                  )}
                </Stack>
              }
            >
              <HStack w="full" justify="flex-start">
                <Box
                  boxSize={2.5}
                  bg={o?.color}
                  borderRadius={3}
                  border="1px solid"
                  borderColor={customTheme.colors.gray['250']}
                />
                <Box
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  flex={1}
                >
                  {o?.value} ({formatNumber(o?.payload?.value, 1)})
                </Box>
              </HStack>
            </CustomTooltip>
          </Box>
        ))}
      </Stack>
    </VStack>
  </Center>
);
